import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import { IconClose } from 'components/Icon/Close';
import Link from 'components/Link';
import { marquee as MarqueePropType } from 'lib/CustomPropTypes';

const stripTags = (content) => content.replace(/<[^>]+>/g, '');

function Breaking(props) {
  const {
    dismissMarquee,
    marquee,
  } = props;

  const content = get(marquee, 'body[0].html', '');
  const primaryUrl = get(marquee, 'item.url.primary', false);

  return (
    <div className="breaking-marquee dn-print">
      <div className="breaking-marquee__inner">
        {(() => {
          // Linked to content.
          if (primaryUrl) {
            return (
              <Link to={primaryUrl} className="breaking-marquee__content">
                {stripTags(content || 'Breaking news')}
                <span className="breaking-marquee__icon icon icon-arrow-link" />
              </Link>
            );
          }
          // Links within text.
          if (content.search(/<a href/) !== -1) {
            /* eslint-disable react/no-danger */
            return (
              <p className="breaking-marquee__content">
                <span dangerouslySetInnerHTML={{ __html: content }} />
                <span className="breaking-marquee__icon icon icon-arrow-link" />
              </p>
            );
            /* eslint-enable react/no-danger */
          }
          // Just text.
          return (
            <p className="breaking-marquee__content">
              {content}
            </p>
          );
        })()}
        <button
          aria-label="Close"
          className="breaking-marquee__close-button"
          onClick={dismissMarquee}
          type="button"
        >
          <IconClose />
        </button>
      </div>
    </div>
  );
}

Breaking.propTypes = {
  dismissMarquee: PropTypes.func,
  marquee: MarqueePropType.isRequired,
};

Breaking.defaultProps = {
  dismissMarquee: Function.prototype,
};

export { Breaking };
